import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'
import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'

/**
 * 采购需求
 * @type {import('@/router').RouteConfig}
 */
const DEMAND_ROUTE = {
  path: 'demand',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '采购需求',
    layout: 'DefaultLayout'
  },
  defaulted: false,
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.PURCHASER_DEMAND.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],
  children: [
    // 采购申请
    {
      path: 'apply',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '采购申请',
        icon: 'icon-side_demand_apply',
        layout: 'DefaultLayout'
      },
      defaulted: false,
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER_DEMAND.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],
      children: [
        // 采购需求申请列表
        {
          path: 'list',
          name: 'DemandApplyList',
          component: '/demand-views/apply/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '申请列表',
            cache: true,
            layout: 'DefaultLayout',
            hidden: true
          },
          defaulted: false,
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER_DEMAND.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        // 采购需求新建申请
        {
          path: 'requirementId/:requirementId?/create',
          name: 'DemandApplyCreate',
          component: '/demand-views/apply/create',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '新建申请',
            hidden: true,
            layout: 'DefaultLayout'
          },
          defaulted: false,
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        // 采购需求申请详情
        {
          path: 'requirementId/:requirementId/detail',
          name: 'DemandApplyDetail',
          component: '/demand-views/apply/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '申请详情',
            hidden: true,
            layout: 'DefaultLayout'
          },
          defaulted: false,
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },
    // 采购任务
    {
      path: 'apply-handle',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '采购任务',
        icon: 'icon-side_demand_handle',
        layout: 'DefaultLayout'
      },
      defaulted: false,
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],
      children: [
        // 任务列表
        {
          path: 'list',
          name: 'DemandApplyHandleList',
          component: '/demand-views/apply-handle/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '任务列表',
            cache: true,
            hidden: true
          },
          defaulted: false,
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },
    // 采购方案
    {
      path: 'plan',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '采购方案',
        icon: 'icon-side_demand_plan',
        layout: 'DefaultLayout'
      },
      defaulted: false,
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],
      children: [
        // 方案列表
        {
          path: 'list',
          name: 'DemandPlanList',
          component: '/demand-views/plan/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '方案列表',
            cache: true,
            hidden: true
          },
          defaulted: false,
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        // 制定方案
        {
          path: 'planId/:planId?/create',
          name: 'DemandPlanCreate',
          component: '/demand-views/plan/create',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '制定方案',
            hidden: true
          },
          defaulted: false,
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        // 方案详情
        {
          path: 'planId/:planId/detail',
          name: 'DemandPlanDetail',
          component: '/demand-views/plan/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '方案详情',
            hidden: true
          },
          defaulted: false,
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },
    // 交货地点
    {
      path: 'address',
      name: 'DemandAddress',
      component: '/demand-views/address',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '交货地点',
        icon: 'icon-side-jiaohuodidianpeizhi',
        layout: 'DefaultLayout'
      },
      defaulted: false,
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
export default DEMAND_ROUTE
